import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import clsx from 'clsx';
import { Icon } from '@mui/material';

import { MEDIA_TYPES, MEDIA_UPLOAD_STATUS } from '../../../../../constants';
import CommonDropzone from '../../../../../components/common-dropzone/CommonDropzone';

import scss from './UploadZone.module.scss';

function UploadZone({
  onUploadMediaItems,
  onChangeErrors,
  labelText = '',
  subLabelText = '',
  iconSize = '6rem',
  flexDirection = 'column',
}) {
  const handleUpload = async (files, options) => {
    const newItems = await Promise.all(
      files.map(async (file) => {
        const type = getMediaType(file);

        return {
          id: uuidv4(),
          file,
          preview: URL.createObjectURL(file),
          tags: [],
          thirdPartyRights: false,
          expirationDate: null,
          type,
          name: file.name,
          size: file.size,
          status: MEDIA_UPLOAD_STATUS.PENDING,
          convertStatus: null,
          progress: 0,
          uploadedBytes: 0,
        };
      }),
    );

    onUploadMediaItems(newItems);

    if (options[0]?.length) {
      onChangeErrors((prev) => [...prev, ...options[0]]);
    }
  };

  return (
    <CommonDropzone
      onDrop={handleUpload}
      dropzoneProps={{
        accept: {
          'image/jpeg': ['.jpeg', '.jpg'],
          'image/png': ['.png'],
          'image/webp': ['.webp'],
          'image/tiff': ['.tif', '.tiff'],

          'video/mp4': ['.mp4', '.m4v', '.m4p'],
          'video/webm': ['.webm'],
          'video/x-msvideo': ['.avi'],
          'video/quicktime': ['.mov', '.movie', '.qt'],
          'video/x-ms-wmv': ['.wmv'],
          'video/x-matroska': ['.mkv'],

          'image/vnd.adobe.photoshop': ['.psd', '.psb'],
          'application/octet-stream': ['.psd', '.psb'],
        },
        multiple: true,
      }}
      className={scss.dropzone}>
      {({ isDragAccept }) => (
        <div className={scss.uploaderBlock} style={{ flexDirection }}>
          <Icon
            component={AddPhotoAlternateOutlinedIcon}
            style={{ width: iconSize, height: iconSize }}
            baseClassName={clsx(scss.uploaderIcon, isDragAccept && scss.uploaderIconFocused)}
          />
          <div className={scss.uploaderTextWrapper}>
            {labelText ? <span className={scss.uploaderText}>{labelText}</span> : null}
            {subLabelText ? <span className={scss.uploaderSubText}>{subLabelText}</span> : null}
          </div>
        </div>
      )}
    </CommonDropzone>
  );
}

export default UploadZone;

const getMediaType = (file) => {
  if (file.type.startsWith('video/')) return MEDIA_TYPES.VIDEO;
  if (file.type.startsWith('image/')) return MEDIA_TYPES.IMAGE;
  if (file.type.startsWith('application/')) return MEDIA_TYPES.APPLICATION;
  return MEDIA_TYPES.APPLICATION;
};
